<!--
NOT REFACTORED FOR V2.1 YET
-->

<template>
    <div>
        <div id="active-chat-log">
            <b-row
                v-for="(entryGrp, index) in formattedActiveChatData.formattedActiveChatLog"
                :key="String(index)"
                :class="{
                    'chat-log-event text-center': entryGrp.type === 'event',
                }"
                class="chat"
            >
                <b-col cols="12">
                    <template v-if="lastEntryId">
                        <component
                            :is="`activeChatLogEntriesEmail${startCase(entry.type)}`"
                            v-for="entry in entryGrp.entries"
                            :key="entry.id"
                            :active-chat="activeChat"
                            :channel="activeChat.channel"
                            :entry="entry"
                            :formatted-active-chat-data="formattedActiveChatData"
                            :is-send-pending="isSendPending"
                            :last-entry-id="lastEntryId"
                            :sender="resolveSender(entry, entryGrp.sender)"
                            :set-iframe-properties="setIframeProperties"
                            @load-editor-content="loadContentEditor"
                        />
                    </template>
                </b-col>
            </b-row>

            <b-row
                v-if="
                    !showFormFields.editor &&
                    (!shouldAssignV21(activeChat.channel) ||
                        (shouldAssignV21(activeChat.channel) &&
                            isChatAssignedToMeV21(activeChat.lastConversation.assignedUserId)))
                "
            >
                <b-col cols="12">
                    <b-card>
                        <div class="d-flex justify-content-between">
                            <h5 class="mb-0">
                                {{ $t("Click here to") }}
                                <b-link @click="showFormFields.editor = true">
                                    {{ $t("entities.email.reply") }}
                                </b-link>
                            </h5>
                        </div>
                    </b-card>
                </b-col>
            </b-row>

            <b-card v-if="showFormFields.editor">
                <b-form>
                    <b-form-group
                        id="fieldset-name"
                        :label="$t('entities.email.subject')"
                        content-cols-lg="10"
                        content-cols-sm
                        label-cols-lg="2"
                        label-cols-sm="12"
                        label-for="subject"
                    >
                        <b-form-input id="subject" v-model="chatEntryInput.metadata.subject" type="text" />
                    </b-form-group>

                    <b-form-group
                        id="fieldset-sender"
                        :label="$t('entities.email.from')"
                        content-cols-lg="10"
                        content-cols-sm
                        label-cols-lg="2"
                        label-cols-sm="12"
                        label-for="sender"
                    >
                        {{ resolveSenderName(activeChat.channel) }}
                    </b-form-group>

                    <b-form-group
                        v-if="showFormFields.cc"
                        id="fieldset-cc"
                        :label="$t('entities.email.cc')"
                        content-cols-lg="10"
                        content-cols-sm
                        label-cols-lg="2"
                        label-cols-sm="12"
                        label-for="cc"
                    >
                        <b-form-tags v-model="chatEntryInput.metadata.cc" input-id="cc" placeholder="" />
                    </b-form-group>

                    <b-form-group
                        v-if="showFormFields.bcc"
                        id="fieldset-bcc"
                        :label="$t('entities.email.bcc')"
                        content-cols-lg="10"
                        content-cols-sm
                        label-cols-lg="2"
                        label-cols-sm="12"
                        label-for="bcc"
                    >
                        <b-form-tags v-model="chatEntryInput.metadata.bcc" input-id="bcc" placeholder="" />
                    </b-form-group>

                    <div ref="dropZoneRef" class="message-editor mb-1">
                        <div v-if="isOverDropZone" class="dropzone email">
                            <font-awesome-icon icon="file" size="2xl" />
                            <p class="mt-1">{{ $t("upload.drop-to-upload") }}</p>
                        </div>

                        <quill-editor
                            v-show="!isOverDropZone"
                            id="quilContent"
                            ref="quillInstance"
                            v-model="chatEntryInput.message"
                            :options="editorOption"
                            name="quilContent"
                            @blur="
                                setStoredMessages({
                                    chatId: activeChat.lastConversation.id,
                                    inboxModuleType,
                                    message: chatEntryInput.message,
                                })
                            "
                            @ready="onQuillEditorReady($event)"
                        />
                        <div v-show="!isOverDropZone" id="quill-toolbar" class="d-flex">
                            <button class="ql-bold" />
                            <button class="ql-italic" />
                            <button class="ql-underline" />
                            <button class="ql-align" />
                            <button class="ql-link" />
                            <button class="ql-list" value="ordered" />
                            <button class="ql-list" value="bullet" />
                            <select :title="$t('settings.channels.email.text-color')" class="ql-color" />
                        </div>
                    </div>

                    <div class="mb-1">
                        <span v-for="asset in files" class="mr-1">
                            <font-awesome-icon :icon="resolveContentTypeIcon(asset.contentType)" class="mr-1" />
                            {{ asset.originalName }}
                            <b-button variant="flat-primary" @click="$emit('remove-file', asset)">
                                <font-awesome-icon icon="times" />
                            </b-button>
                        </span>

                        <b-spinner v-if="isLoadingFiles" :label="$t('loading')" variant="primary" />
                    </div>

                    <b-row>
                        <b-col cols="3">
                            <b-button variant="light" @click="cancelCompose">
                                {{ $t("Cancel") }}
                            </b-button>
                        </b-col>
                        <b-col class="text-right" cols="9">
                            <b-button variant="flat-light" @click="showFormFields.cc = true">
                                {{ $t("entities.email.cc") }}
                            </b-button>
                            <b-button variant="flat-light" @click="showFormFields.bcc = true">
                                {{ $t("entities.email.bcc") }}
                            </b-button>
                            <b-button
                                v-b-tooltip.hover.top="$t('Attachments')"
                                class="btn-icon mr-1"
                                variant="flat-light"
                                @click="openFilePrompt"
                            >
                                <font-awesome-icon icon="paperclip" />

                                <b-form-file
                                    v-show="false"
                                    id="files"
                                    multiple
                                    @input="$emit('upload-files', $event)"
                                />
                            </b-button>

                            <b-button
                                v-b-tooltip.hover.top="$t('entities.quick-replies.Quick replies')"
                                class="btn-icon mr-1"
                                variant="flat-light"
                                @click="$bvModal.show('modal-quick-replies')"
                            >
                                <font-awesome-icon class="mr-1" icon="slash-forward" />
                            </b-button>

                            <b-button
                                :disabled="isSendPending || !chatEntryInput.metadata.subject || !chatEntryInput.message"
                                variant="primary"
                                @click="sendMessage"
                            >
                                {{ $t("Send") }}
                                <b-spinner v-if="isSendPending" small></b-spinner>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card>

            <active-chat-scroll-to-bottom @scroll-to-bottom="$emit('scroll-to-bottom', $event)" />
        </div>

        <b-modal
            id="modal-quick-replies"
            :ok-title="$t('Close')"
            centered
            content-class="h-100 h-lg-75 pb-4 p-0 m-0"
            dialog-class="w-auto w-lg-75 mw-100"
            header-close-variant="light"
            hide-footer
            scrollable
        >
            <quick-replies :active-chat="activeChat" @set-quick-reply="quickReplyItemClicked" />
        </b-modal>
    </div>
</template>

<script>
import useFileUploads from "@/composables/useFileUploads";

// Composables
import useStoredMessages from "@/composables/v2.1/useStoredMessages";
import i18n from "@/libs/i18n";
import SaysimpleCorrespondenceSeparator from "@/libs/quill/saysimpleCorrespondenceSeparator";
import { InboxModuleType } from "@/types/inboxModule.type";
import { isChatAssignedToMeV21, resolveContentTypeIcon, shouldAssignV21 } from "@/utils/chats";
import quickReplies from "@/views/components/inbox/active-chat-templates/quickReplies";
import activeChatAssetPreview from "@/views/components/inbox/active-chat/activeChatAssetPreview";
import activeChatScrollToBottom from "@/views/components/inbox/active-chat/activeChatScrollToBottom.vue";
import activeChatLogEntriesEmailAsset from "@/views/modules/email-inbox/active-chat-log-entries/asset";
import activeChatLogEntriesEmailEvent from "@/views/modules/email-inbox/active-chat-log-entries/event";
import activeChatLogEntriesEmailInternalcomment from "@/views/modules/email-inbox/active-chat-log-entries/internalComment.vue";

// Components
import activeChatLogEntriesEmailText from "@/views/modules/email-inbox/active-chat-log-entries/text";
import useEmailActiveChat from "@/views/modules/email-inbox/useEmailActiveChat"; // @v21 old.
import { computed, nextTick, ref, watch } from "@vue/composition-api";
import { useDropZone } from "@vueuse/core";
import {
    BButton,
    BCard,
    BCol,
    BDropdown,
    BForm,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormTags,
    BLink,
    BModal,
    BOverlay,
    BRow,
    BSpinner,
    VBModal,
    VBTooltip,
} from "bootstrap-vue";
import { startCase } from "lodash";
import ImageResize from "quill-image-resize-vue";

// WYSIWYG
import { Quill, quillEditor } from "vue-quill-editor";

Quill.register("modules/imageResize", ImageResize);
Quill.register(SaysimpleCorrespondenceSeparator, true);

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BLink,
        BDropdown,
        BButton,
        BFormGroup,
        BForm,
        BFormInput,
        BFormFile,
        BFormTags,
        BSpinner,
        BOverlay,
        BModal,
        quillEditor,
        activeChatLogEntriesEmailText,
        activeChatLogEntriesEmailEvent,
        activeChatLogEntriesEmailAsset,
        activeChatLogEntriesEmailInternalcomment,
        activeChatAssetPreview,
        activeChatScrollToBottom,
        quickReplies,
    },
    directives: {
        "b-modal": VBModal,
        "b-tooltip": VBTooltip,
    },
    props: {
        activeChat: {
            type: Object,
            required: true,
        },
        files: {
            type: Array,
            required: false,
        },
        isLoadingFiles: {
            type: Boolean,
            required: true,
        },
        chatEntryInput: {
            type: Object,
            required: true,
        },
        isSendPending: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        openFilePrompt() {
            document.getElementById("files").click();
        },
        handleShowScrollToBottomButton(isVisible) {
            this.scrollToBottomButtonVisible = !isVisible;
        },
        loadContentEditor() {
            this.showFormFields.editor = true;
            //this.$emit("scroll-to-bottom");
        },
    },
    setup(props, { emit, root }) {
        const { resolveSenderName, setIframeProperties, resolveReplyMessage } = useEmailActiveChat(); // v21 - this is old, no time to refactor.
        const { removeStoredMessage, setStoredMessages } = useStoredMessages();
        const { clearFiles } = useFileUploads();

        const quillInstance = ref();
        const showFormFields = ref({
            editor: false,
            cc: false,
            bcc: false,
        });

        const scrollToBottomButtonVisible = ref(false);

        nextTick(() => emit("scroll-to-bottom"));

        watch(
            () => props.activeChat.lastConversation.id,
            () => {
                showFormFields.value.editor = false;
                clearFiles(); // this is done for now, because uploaded files are not stored in the localStorage.

                nextTick(() => emit("scroll-to-bottom"));
            }
        );

        watch(
            () => props.activeChat.chatLog,
            (chatLog) => {
                // here we will check if we got no message
                // and set the reply to true we check 2 entries because a new chat got an entries
                // in the if I put one because new chats got one preloaded chats
                if (chatLog.some((log) => log.entries.length <= 1)) {
                    showFormFields.value.editor = true;
                }
            },
            { immediate: true }
        );

        // Drag and drop files to upload.
        const dropZoneRef = ref(null);
        const onFileDrop = (files) => {
            emit("upload-files", files);
        };
        const { isOverDropZone } = useDropZone(dropZoneRef, onFileDrop);

        const onQuillEditorReady = (editor) => {
            // Find the last conversation so we know what the latest subject is to reply on.
            const conversation = props.activeChat.chatLog.find(
                (conversation) => conversation.id === props.activeChat.lastConversation.id
            );
            const entries = conversation.entries.filter((entry) => entry.type !== "event");

            if (entries.length > 0) {
                const metadata = entries[entries.length - 1].metadata;
                const subject = metadata.find((meta) => meta.name === "subject")?.value;
                props.chatEntryInput.metadata.subject = `RE: ${subject}`;
            } else {
                props.chatEntryInput.metadata.subject = "";
            }

            props.chatEntryInput.message = resolveReplyMessage(props.activeChat);
            editor.focus();

            nextTick(() => emit("scroll-to-bottom"));
        };

        const cancelCompose = () => {
            removeStoredMessage({
                chatId: props.activeChat.lastConversation.id,
                inboxModuleType: InboxModuleType.EMAIL,
            });

            clearFiles();

            showFormFields.value.editor = false;
        };

        const sendMessage = () => {
            emit("send-message");

            showFormFields.value.editor = false;
        };

        // @TODO v21 check if this differs from the same function in activeChatLog.vue, so we can create one function for both.
        const formattedActiveChatData = computed(() => {
            const contact = {
                id: props.activeChat.contact?.id,
                name: props.activeChat.contact?.name,
            };

            const channel = {
                platform: props.activeChat.channel.platform,
            };

            let assignee;
            if (props.activeChat.assignee) {
                assignee = {
                    id: props.activeChat.assignee.id,
                    name: props.activeChat.assignee.name,
                };
            }

            let chatConversations = [];
            if (props.activeChat.chatLog) {
                chatConversations = props.activeChat.chatLog;
            }

            let activeChatLog = [];
            chatConversations.map((conversation) => {
                activeChatLog.push({
                    actor: undefined,
                    conversationId: conversation.id,
                    id: conversation.identityId,
                    name: "Conversation::start",
                    payload: undefined,
                    target: undefined,
                    time: conversation.start,
                    type: "event",
                });

                if (conversation.entries) {
                    activeChatLog.push(...conversation.entries);
                }
            });

            const formattedActiveChatLog = [];

            if (!activeChatLog[0]) {
                return { formattedActiveChatLog };
            }

            // Pick first message of the contact (identityId) or agent (userId), so we can group multiple messages per sender.
            // First initial group.
            let chatMessageSenderId = activeChatLog[0]
                ? activeChatLog[0].userId ?? activeChatLog[0].identityId
                : undefined;
            let chatMessageDirection = activeChatLog[0] ? activeChatLog[0].direction : undefined;
            let entryGroup = {
                id: activeChatLog[0].id,
                type: activeChatLog[0].type,
                direction: chatMessageDirection,
                sender:
                    activeChatLog[0].type !== "event"
                        ? {
                              id: chatMessageSenderId,
                              name:
                                  chatMessageDirection === "out"
                                      ? resolveSenderName(props.activeChat.channel)
                                      : contact.name,
                              identity:
                                  chatMessageDirection === "out"
                                      ? props.activeChat.channel.name
                                      : props.activeChat.identity.identity,
                          }
                        : undefined,
                entries: [],
            };

            activeChatLog.forEach((entry, index) => {
                if (chatMessageDirection === entry.direction) {
                    entryGroup.entries.push(entry);
                } else {
                    chatMessageSenderId = entry.userId ?? entry.identityId;
                    chatMessageDirection = entry.direction;

                    formattedActiveChatLog.push(entryGroup);
                    entryGroup = {
                        id: entry.id,
                        type: entry.type,
                        direction: entry.direction,
                        sender:
                            entry.type !== "event"
                                ? {
                                      id: chatMessageSenderId,
                                      name:
                                          entry.system === 1
                                              ? i18n.t("automated-message")
                                              : entry.direction === "out"
                                              ? resolveSenderName(props.activeChat.channel)
                                              : contact.name,
                                      identity:
                                          chatMessageDirection === "out"
                                              ? props.activeChat.channel.name
                                              : props.activeChat.identity.identity,
                                  }
                                : undefined,
                        entries: [entry],
                    };
                }
                if (index === activeChatLog.length - 1) {
                    formattedActiveChatLog.push(entryGroup);
                }
            });

            return {
                formattedActiveChatLog,
                contact,
                channel,
                assignee,
            };
        });

        const lastEntryId = computed(() => {
            const filteredChats = formattedActiveChatData.value.formattedActiveChatLog.filter((entry) =>
                ["text", "asset"].includes(entry.type)
            );
            const lastChat = filteredChats[filteredChats.length - 1];
            if (!lastChat) {
                return;
            }

            return lastChat.entries[lastChat.entries.length - 1].id;
        });

        const editorOption = {
            modules: {
                toolbar: "#quill-toolbar",
                imageResize: {},
                //"emoji-toolbar": true,
                //"emoji-shortname": true,
            },
            placeholder: "",
            //formats: ["span"],
        };

        const quickReplyItemClicked = (quickReply) => {
            const caretPosition = quillInstance.value.quill.selection.savedRange.index;
            quillInstance.value.quill.insertText(caretPosition, quickReply.content);

            root.$bvModal.hide("modal-quick-replies");
        };

        const resolveSender = (entry, fallbackSender) => {
            const fromMetadata = entry.metadata?.find((metadata) => metadata.name === "from");

            if (entry.type !== "text" || !fromMetadata) {
                return fallbackSender;
            }

            let parsedFromMetadata;

            try {
                parsedFromMetadata = JSON.parse(fromMetadata.value);
            } catch {
                return fallbackSender;
            }

            return {
                name: parsedFromMetadata.name,
                identity: parsedFromMetadata.emailAddress,
            };
        };

        return {
            startCase,
            lastEntryId,
            quillInstance,
            editorOption,
            formattedActiveChatData,
            showFormFields,
            scrollToBottomButtonVisible,

            cancelCompose,
            resolveSenderName,
            onQuillEditorReady,
            setIframeProperties,

            isChatAssignedToMeV21,
            resolveContentTypeIcon,
            shouldAssignV21,
            sendMessage,

            dropZoneRef,
            inboxModuleType: InboxModuleType.EMAIL,
            isOverDropZone,
            setStoredMessages,
            quickReplyItemClicked,
            resolveSender,
        };
    },
};
</script>

<style lang="scss">
@import "~@/assets/scss/modules/email-inbox/activeChatLog.scss";
@import "~@/assets/scss/components/inbox/activeChatLog.scss";
// This one is shared across inboxes.
@import "~@/@core/scss/vue/libs/quill.scss";
</style>

<style lang="scss" scoped>
form::v-deep {
    // Quill Editor Style
    .quill-editor {
        color: black;

        .ql-container.ql-snow {
            font-size: 14px;
            font-family: sans-serif;

            border-bottom: 0;
            min-height: 200px;
        }
    }

    .ql-toolbar.ql-snow {
        border-radius: 10px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
}
</style>
